import { render, staticRenderFns } from "./labelPanelStatusBadge.vue?vue&type=template&id=6cf71b9a&"
import script from "./labelPanelStatusBadge.vue?vue&type=script&lang=js&"
export * from "./labelPanelStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports